import { redirect } from "react-router";

type LegacySettingsRedirect = {
    legacyPath: string;
    newPath: string;
};

export const LEGACY_SETTINGS_REDIRECTS: LegacySettingsRedirect[] = [
    { legacyPath: "/settings/features", newPath: "/settings/configuration/platform-setup/modules" },
    { legacyPath: "/settings/scores", newPath: "/settings/configuration/platform-setup/scores" },
    { legacyPath: "/settings/menu-management", newPath: "/settings/configuration/platform-setup/navigation" },
    { legacyPath: "/settings/campaigns", newPath: "/settings/configuration/platform-setup/campaigns" },
    { legacyPath: "/settings/roles", newPath: "/settings/configuration/access-permissions/roles" },
    { legacyPath: "/settings/permissions", newPath: "/settings/configuration/access-permissions/permissions" },
    {
        legacyPath: "/settings/consent-governance",
        newPath: "/settings/configuration/access-permissions/consent-governance",
    },
    { legacyPath: "/settings/theme", newPath: "/settings/configuration/customization-languages/branding" },
    {
        legacyPath: "/settings/custom-theme",
        newPath: "/settings/configuration/customization-languages/branding/custom-theme",
    },
    {
        legacyPath: "/settings/custom-themes",
        newPath: "/settings/configuration/customization-languages/branding/custom-themes",
    },
    { legacyPath: "/settings/csrTheme", newPath: "/settings/configuration/customization-languages/branding/csr-theme" },
    { legacyPath: "/settings/cms/dynablocks", newPath: "/settings/configuration/customization-languages/app-blocks" },
    {
        legacyPath: "/settings/languages",
        newPath: "/settings/configuration/customization-languages/available-languages",
    },
    {
        legacyPath: "/settings/translations",
        newPath: "/settings/configuration/customization-languages/translation-overrides",
    },
    { legacyPath: "/settings/integrations", newPath: "/settings/configuration/connections/integrations" },
    { legacyPath: "/settings/applications", newPath: "/settings/configuration/connections/applications" },
    {
        legacyPath: "/settings/applicationParameters",
        newPath: "/settings/configuration/platform-setup/application-parameters",
    },
    { legacyPath: "/settings/companies", newPath: "/settings/my-organization/companies-suppliers/companies" },
    { legacyPath: "/settings/providers", newPath: "/settings/my-organization/companies-suppliers/suppliers" },
    {
        legacyPath: "/settings/my-organization/consent-governance",
        newPath: "/settings/configuration/access-permissions/consent-governance",
    },
    {
        legacyPath: "/settings/organization-types",
        newPath: "/settings/my-organization/companies-suppliers/organization-types",
    },
    {
        legacyPath: "/settings/company-sectors",
        newPath: "/settings/my-organization/companies-suppliers/industry-sectors",
    },
    { legacyPath: "/settings/brands", newPath: "/settings/my-organization/products-ingredients/brands" },
    { legacyPath: "/settings/product-line", newPath: "/settings/my-organization/products-ingredients/product-lines" },
    {
        legacyPath: "/settings/ingredient-line",
        newPath: "/settings/my-organization/products-ingredients/ingredient-sectors",
    },
    { legacyPath: "/settings/packagings/ssq", newPath: "/settings/my-organization/packaging/packaging-qss" },
    {
        legacyPath: "/settings/additional-object-parameters",
        newPath: "/settings/my-organization/custom-data-taxonomies/custom-attributes",
    },
    { legacyPath: "/settings/tags", newPath: "/settings/my-organization/custom-data-taxonomies/tags" },
    { legacyPath: "/settings/cms/templates", newPath: "/settings/content/pdf-templates" },
    { legacyPath: "/settings/cms", newPath: "/settings/content/pages" },
    { legacyPath: "/settings/media-library", newPath: "/settings/content/media-library" },
    { legacyPath: "/settings/ingredient-references", newPath: "/settings/references/ingredients" },
    { legacyPath: "/settings/questionnaires", newPath: "/settings/references/qss-versions" },
    { legacyPath: "/settings/data-lists-values-overrides", newPath: "/settings/references/custom-data-lists" },
    { legacyPath: "/settings/entity-target-score-assignment", newPath: "/settings/references/sector-score-targets" },
    { legacyPath: "/settings/icvs", newPath: "/settings/references/icvs" },
];

const isSamePathOrChild = (pathname: string, parentPath: string) =>
    pathname === parentPath || pathname.startsWith(`${parentPath}/`);

export const resolveLegacySettingsRedirect = (pathname: string) => {
    const match = LEGACY_SETTINGS_REDIRECTS.find(({ legacyPath }) => isSamePathOrChild(pathname, legacyPath));

    if (!match) {
        return undefined;
    }

    return `${match.newPath}${pathname.slice(match.legacyPath.length)}`;
};

export const resolveSettingsParentPath = (pathname: string) => {
    const canonicalPath = resolveLegacySettingsRedirect(pathname) ?? pathname;
    const pathWithoutTrailingSlash = canonicalPath.replace(/\/+$/, "");
    const lastSlashIndex = pathWithoutTrailingSlash.lastIndexOf("/");

    if (lastSlashIndex <= 0) {
        return pathWithoutTrailingSlash;
    }

    return pathWithoutTrailingSlash.slice(0, lastSlashIndex);
};

export const legacySettingsRedirectLoader = ({ request }: { request: Request }) => {
    const url = new URL(request.url);
    const redirectPath = resolveLegacySettingsRedirect(url.pathname);

    if (!redirectPath) {
        return null;
    }

    return redirect(`${redirectPath}${url.search}${url.hash}`, 301);
};
